const EnvBadge = ({ active, label, onClick, disabled }) => (
  <button
    onClick={onClick}
    type='button'
    disabled={disabled}
    className={`px-3 md:px-4 py-2 rounded-xl text-[9px] md:text-[10px] font-black uppercase tracking-[0.2em] border transition-all duration-300 whitespace-nowrap
      ${active ? 'bg-orange-500/10 border-orange-500 text-orange-500 shadow-[0_0_15px_rgba(249,115,22,0.1)]' : 'bg-transparent border-white/5 text-gray-700 hover:border-white/20 hover:text-gray-400'}
      ${disabled ? 'opacity-40 cursor-not-allowed border-dashed' : ''}
    `}
  >
    .{label}
  </button>
);

export default EnvBadge